import { jsx as _jsx } from "react/jsx-runtime";
import { useEditor } from "../../../hooks/EditorProvider";
import { default as NextLink } from "next/link";
import { useSite } from "../../../hooks/SiteProvider";
const Link = ({ href, className, children, target = "_self", page, handleLinkClick, ...props }) => {
    const { mode } = useEditor();
    const { pages, locale, defaultLocale } = useSite();
    const handleClick = (event) => {
        if (mode !== "production") {
            event.preventDefault();
        }
        if (handleLinkClick) {
            handleLinkClick();
        }
    };
    let linkHref = href;
    if (page && mode === "production") {
        const pageObject = pages.find((p) => p.uuid === page);
        const pageData = pageObject?.data.find((d) => d.language.code === locale.toUpperCase());
        if (pageData) {
            if (locale !== defaultLocale) {
                linkHref = `/${locale}${pageData?.path}`;
            }
            else {
                linkHref = pageData?.path;
            }
        }
    }
    return (_jsx(NextLink, { href: mode === "production" && linkHref ? linkHref : "#", target: target, onClick: handleClick, className: className, ...props, children: children }));
};
export default Link;
//# sourceMappingURL=Link.js.map